import {
	Button,
	ColourStateSolid,
	FilterSelect,
	FormHook,
	FormWrapperLabel,
	ValidationError,
	ValidationPatterns,
} from '@ukpostbox/frontend-framework';
import React, { useState } from 'react';
import { AddressExamples } from '../../_Global/Data/SignUp';

interface AddressLookupInterface extends FormHook {}

function AddressLookup(props: AddressLookupInterface) {
	const [addressData, setAddressData] = useState<Array<any>>([]);
	const [manualAddress, setManualAddress] = useState<boolean>(false);

	const UpdateData = () => {
		// TODO: fetch address lookup data from endpoint
		setAddressData(AddressExamples);
	};

	const HandleAddressCallback = (address: any) => {
		props.setValue('propertyNameNumber', address.propertyNameNumber, { shouldValidate: true });
		props.setValue('street', address.street, { shouldValidate: true });
		props.setValue('townCity', address.townCity, { shouldValidate: true });
		props.setValue('county', address.county, { shouldValidate: true });
		props.setValue('postcode', address.postCode, { shouldValidate: true });
		props.setValue('countryCode', address.countryCode, { shouldValidate: true });
	};

	const HandleManualLookup = () => {
		setManualAddress(!manualAddress);
	};

	return (
		<div className='address-wrapper'>
			<FormWrapperLabel
				hideValidationMessage
				label={props.label}
				addonEnd={
					<Button
						onClick={() => HandleManualLookup()}
						colour={manualAddress ? ColourStateSolid.Selected : ColourStateSolid.Secondary}
						title='Manually Enter'
					/>
				}
				invalid={!manualAddress && props.errors.countryCode && props.errors.countryCode?.message !== ''}
			>
				<FilterSelect
					isRequired
					dynamicDataSource
					id='addAddress'
					data={addressData}
					placeholderLabel='Type to Search...'
					updatedCallback={(val: any) => HandleAddressCallback(val)}
					userInputCallback={() => UpdateData()}
					disabled={manualAddress}
				/>
			</FormWrapperLabel>

			<ValidationError
				value={
					!manualAddress && props.errors.countryCode && props.errors.countryCode?.message !== ''
						? 'Lookup required'
						: ''
				}
			/>

			<div className={`manual-address-details ${!manualAddress && 'hide'}`}>
				<FormWrapperLabel
					label='Property Name/Number'
					invalid={props.errors.propertyNameNumber && props.errors.propertyNameNumber?.message !== ''}
					validationMessage={props.errors.propertyNameNumber?.message as string}
				>
					<input
						type='text'
						aria-invalid={props.errors.propertyNameNumber ? 'true' : 'false'}
						{...props.register('propertyNameNumber', { required: 'This is a required field' })}
					/>
				</FormWrapperLabel>

				<FormWrapperLabel
					label='Street'
					invalid={props.errors.street && props.errors.street?.message !== ''}
					validationMessage={props.errors.street?.message as string}
				>
					<input
						type='text'
						aria-invalid={props.errors.street ? 'true' : 'false'}
						{...props.register('street', { required: 'This is a required field' })}
					/>
				</FormWrapperLabel>

				<FormWrapperLabel
					label='Town/City'
					invalid={props.errors.townCity && props.errors.townCity?.message !== ''}
					validationMessage={props.errors.townCity?.message as string}
				>
					<input
						type='text'
						aria-invalid={props.errors.townCity ? 'true' : 'false'}
						{...props.register('townCity', { required: 'This is a required field' })}
					/>
				</FormWrapperLabel>

				<FormWrapperLabel
					label='County'
					invalid={props.errors.county && props.errors.county?.message !== ''}
					validationMessage={props.errors.county?.message as string}
				>
					<input
						type='text'
						aria-invalid={props.errors.county ? 'true' : 'false'}
						{...props.register('county', { required: 'This is a required field' })}
					/>
				</FormWrapperLabel>

				<FormWrapperLabel
					label='Post Code'
					invalid={props.errors.postcode && props.errors.postcode?.message !== ''}
					validationMessage={props.errors.postcode?.message as string}
				>
					<input
						type='text'
						aria-invalid={props.errors.postcode ? 'true' : 'false'}
						{...props.register('postcode', { required: 'This is a required field' })}
					/>
				</FormWrapperLabel>

				<FormWrapperLabel
					label='Country'
					invalid={props.errors.countryCode && props.errors.countryCode?.message !== ''}
					validationMessage={props.errors.countryCode?.message as string}
				>
					<input
						type='text'
						aria-invalid={props.errors.countryCode ? 'true' : 'false'}
						{...props.register('countryCode', {
							pattern: { value: ValidationPatterns.countryCode, message: 'ISO code is invalid' },
							required: 'This is a required field',
						})}
					/>
				</FormWrapperLabel>
			</div>
		</div>
	);
}

export default AddressLookup;
